import Link from 'next/link'
import React, { FC, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { cn } from '@lib/cn'
import { OldText } from '@gassan-ui'

type MembershipNavigationItemProps = {
  href: string
  title: string
  status: 'active' | 'idle'
  icon: React.ReactNode
}

export const MembershipNavigationItem: FC<MembershipNavigationItemProps> = ({
  href,
  title,
  status,
  icon,
}) => {
  const isActive = status === 'active'
  const [ref, inView, entry] = useInView({
    threshold: 1,
    triggerOnce: true,
  })
  useEffect(() => {
    if (status === 'active' && !inView && entry?.target) {
      entry.target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }, [status, inView, entry])

  return (
    <Link href={href}>
      <a
        ref={ref}
        className={cn(
          'relative flex w-full flex-col items-center py-1 sm:py-2 xl:px-4 xl:py-3',
          isActive ? 'text-shade-800' : 'text-shade-600',
        )}
      >
        {icon}
        <OldText variant="regular" mb="0" color="inherit">
          {title}
        </OldText>
        {isActive && <span className="absolute bottom-[-4px] h-[1px] w-full bg-tabaccoBrown" />}
      </a>
    </Link>
  )
}
